'use strict';
const BaseTooltip=require('../../../../dist-es6/client/directives/tooltips/baseTooltip');let

TextTooltipDirective=class TextTooltipDirective extends BaseTooltip{
get template(){
return'<div class="tooltip-body"><p ng-repeat="line in textContent.split(\'\\n\')" class="tooltip-text">{{line}}</p></div>';
}};


module.exports=TextTooltipDirective;
//# sourceMappingURL=textTooltipDirective.js.map
